import React from "react";
import { stack as Menu } from "react-burger-menu";
import { useSelector } from 'react-redux';


export default props => {
    const user = useSelector(state => state.user);

    return (
        // Pass on our props
        <React.Fragment>
            <span><i class="cil-hamburger-menu"></i></span>
            <Menu isOpen={props.homeBurgerState} {...props} right>
                <a className="menu-item" href="/">Home</a>
                {(user.email) ?
                    <React.Fragment>
                        <a className="menu-item bm-item display-block" href="/profile"><i style={{ marginRight: "2%" }} class="fa fa-address-book a-10x" aria-hidden="true"></i>Profile</a>
                        <a className="menu-item bm-item display-block" href="/cart"><i style={{ marginRight: "2%" }} class="fa fa-shopping-cart a-10x" aria-hidden="true"></i>Cart</a>
                        {(user.role === "SELLER") && <a className="menu-item bm-item display-block" href="/dashboard"><i style={{ marginRight: "2%" }} class="fa fa-address-book a-10x" aria-hidden="true"></i>Dashboard</a>}
                        <a className="menu-item bm-item display-block" href="/"><i style={{ marginRight: "2%" }} class="fa fa-address-book a-10x" aria-hidden="true"></i>Message</a>
                        <a className="menu-item bm-item display-block" href="/profile/pre-orders"><i style={{ marginRight: "2%" }} class="fa fa-address-book a-10x" aria-hidden="true"></i>Orders</a>
                        <a className="menu-item bm-item display-block" onClick={() => { window.location.replace('/logout') }}><i style={{ marginRight: "2%" }} class="fa fa-sign-out a-10x" aria-hidden="true"></i>Logout</a>
                    </React.Fragment> :
                    <React.Fragment>
                        <a className="menu-item bm-item display-block" href="/join"><i style={{ marginRight: "2%" }} class="fa fa-user-plus a-10x" aria-hidden="true"></i>Join</a>
                        <a className="menu-item bm-item display-block" href="/login"><i style={{ marginRight: "2%" }} class="fa fa-sign-in a-10x" aria-hidden="true"></i>Login</a>
                    </React.Fragment>}
                <a className="menu-item" href="/"><i style={{ marginRight: "2%" }} class="fa fa-address-book a-10x" aria-hidden="true"></i>Contact-us</a>
                <a className="menu-item" href="/blog"><i style={{ marginRight: "2%" }} class="fa fa-rss a-10x" aria-hidden="true"></i>Blog</a>
                <a className="menu-item" href="/news"><i style={{ marginRight: "2%" }} class="fa fa-newspaper-o a-10x" aria-hidden="true"></i>News</a>
                <a className="menu-item" href="/tour"><i style={{ marginRight: "2%" }} class="fa fa-briefcase a-10x" aria-hidden="true"></i>Add Your Business</a>
            </Menu>
        </React.Fragment>
    );
};
